export default "__VITE_ASSET__banKqQ8O__"